export enum UserProfileTypeListItem {
  DepartmentUser = 1,
  AgencyUser = 2,
  ExternalDepartmentUser = 3,
}

export class UserProfileTypeDto {
  constructor() { }
  public static readonly type = UserProfileTypeListItem;

  public userProfileTypeId: number;
  public userProfileTypeName: string;
}
